import Vue from 'vue';
import { formatComponentName } from './format';
// import recordHttpLog from './recordHttpLog';
// 页面接口请求监控
import './XMLHttpRequest';

// 上传错误信息
import postError from './postError';

// console.log(window.navigator.userAgent, '系统信息');

// vue自带的捕获错误方式（包括钩子
Vue.config.errorHandler = (err, vm, info) => {
  if (vm) {
    var componentName = formatComponentName(vm);
    postError({vueErr: err, vueInfo: info, vueComponentName: '（组件名称）' + componentName});
  } else {
    postError({vueErr: err, vueInfo: info});
  }
  console.error('通过vue errorHandler捕获的错误', err, vm ? '组件名称：' + formatComponentName(vm) : '');
};

// 系统错误
window.onerror = function(message, source, lineno, colno, error) {
  console.error('捕获一部分的window的错误：', message, source, lineno, colno, error);
  postError({windowErrMessage: message, windowErrSource: source, windowErrLineno: lineno, windowErrColno: colno, windowErrInfo: error});
};
// window.addEventListener('error', (event) => {
//   console.error('捕获一部分的事件的错误啦啦：', event);
// });

// 回调中的报错监听(未处理的弹出) Promise
window.addEventListener('unhandledrejection', event => {
  console.error('回调中的报错监听 2222', event); // 打印"Unhandle Promise Error!"
  postError({jsRejectionErr: event.reason, jsRejectionStack: event.reason.stack});
});

/**
 * 页面接口请求监控
 */
// XMLHttpRequest.init((event, loadArr) => {
//   let url = event.detail.responseURL;
//   let status = event.detail.status;
//   let statusText = event.detail.statusText;
//   let responseText = event.detail.responseText;
//   if (status !== 200 && url.indexOf('/big-web/error-log') === -1) {
//     console.error('请求报错了：', url, '' + status, statusText, event, loadArr, '请求参数：', loadArr);
//     postError({ajaxUrl: url, ajaxStatus: status, ajaxStatusText: statusText, ajaxResponseTest: responseText});
//   }
// });
